import React from 'react';
import { Alert } from 'reactstrap';
import api from '../Api';

class ConnectionStatus extends React.Component {
  state = {
    isOnline: navigator.onLine,
    showAlert: false,
    alertMessage: '',
    alertType: 'success',
    connectionSpeed: 'unknown',
    lastDismissedTime: 0, 
    manuallyDismissed: false 
  };

  DISMISS_COOLDOWN = 300000; 
  SLOW_CONNECTION_CHECK_INTERVAL = 10000; 

  // Adiciona variável para controlar o timer
  alertTimeout = null;
  connectionCheckInterval = null;

  componentDidMount() {
    window.addEventListener('online', this.handleOnline);
    window.addEventListener('offline', this.handleOffline);
    
    // Monitora mudanças na conexão
    if ('connection' in navigator) {
      navigator.connection.addEventListener('change', this.handleConnectionChange);
      this.checkConnectionSpeed();
    }
    
    this.setupApiMonitoring();

    // Adiciona verificação periódica da conexão
    this.connectionCheckInterval = setInterval(() => {
      if (!this.state.manuallyDismissed || 
          Date.now() - this.state.lastDismissedTime > this.DISMISS_COOLDOWN) {
        this.checkConnectionSpeed();
      }
    }, this.SLOW_CONNECTION_CHECK_INTERVAL);
  }

  componentWillUnmount() {
    window.removeEventListener('online', this.handleOnline);
    window.removeEventListener('offline', this.handleOffline);
    if ('connection' in navigator) {
      navigator.connection.removeEventListener('change', this.handleConnectionChange);
    }
    
    if (this.alertTimeout) {
      clearTimeout(this.alertTimeout);
    }
    if (this.connectionCheckInterval) {
      clearInterval(this.connectionCheckInterval);
    }
  }

  showTemporaryAlert = (message, type) => {
    // Não mostra alerta se foi fechado manualmente recentemente
    if (this.state.manuallyDismissed && 
        Date.now() - this.state.lastDismissedTime < this.DISMISS_COOLDOWN) {
      return;
    }

    // Limpa qualquer timer existente
    if (this.alertTimeout) {
      clearTimeout(this.alertTimeout);
    }

    this.setState({
      showAlert: true,
      alertMessage: message,
      alertType: type,
      manuallyDismissed: false
    });

    // Define novo timer
    this.alertTimeout = setTimeout(() => {
      this.setState({ showAlert: false });
    }, 60000);
  }

  checkConnectionSpeed = () => {
    if ('connection' in navigator) {
      const connection = navigator.connection;
      const { effectiveType, downlink } = connection;

      // Verifica se a conexão é lenta
      if (effectiveType === 'slow-2g' || effectiveType === '2g' || downlink < 1) {
        this.showTemporaryAlert(
          'Conexão está lenta. Isso pode afetar o desempenho.',
          'warning'
        );
      }
    }
  }

  handleConnectionChange = () => {
    this.checkConnectionSpeed();
  }

  setupApiMonitoring = () => {
    const originalApi = { ...api };
    
    Object.keys(originalApi).forEach(key => {
      if (typeof originalApi[key] === 'function') {
        api[key] = async (...args) => {
          if (!navigator.onLine) {
            this.handleOffline();
            throw new Error('Offline');
          }

          // Verifica a velocidade antes de cada requisição
          this.checkConnectionSpeed();

          try {
            const response = await originalApi[key](...args);
            return response;
          } catch (error) {
            if (!error.response && !navigator.onLine) {
              this.showTemporaryAlert(
                'Erro de conexão. Verifique sua internet.',
                'warning'
              );
            }
            throw error;
          }
        };
      }
    });
  }

  handleOnline = () => {
    this.showTemporaryAlert('Conexão restabelecida!', 'success');
  }

  handleOffline = () => {
    this.showTemporaryAlert('Sem conexão com a internet', 'danger');
  }

  handleDismiss = () => {
    this.setState({
      showAlert: false,
      manuallyDismissed: true,
      lastDismissedTime: Date.now()
    });
  }

  render() {
    const { showAlert, alertMessage, alertType } = this.state;

    if (!showAlert) return null;

    return (
      <div style={{
        position: 'fixed',
        top: '20px',
        right: '20px',
        zIndex: 9999,
        minWidth: '300px'
      }}>
        <Alert 
          color={alertType}
          isOpen={showAlert}
          toggle={this.handleDismiss}
        >
          <span className="alert-icon">
            <i className={`fas fa-${alertType === 'success' ? 'check' : 'exclamation'}-circle mr-2`}></i>
          </span>
          <span className="alert-text">{alertMessage}</span>
        </Alert>
      </div>
    );
  }
}

export default ConnectionStatus;